import request from '@/utils/request';
import { AxiosPromise } from 'axios';
import { MemberPointsInfoVo, RecordListRequest, MemberPointsRecordVo, MemberPointsTaskVo } from '@/api/member/credits-mall/types';

/**
 *  积分总览
 */
export const memberPointsPointInfo = (): AxiosPromise<MemberPointsInfoVo> => {
  return request({
    url: '/member/points/pointInfo',
    method: 'get'
  });
};

// 每日签到
export const memberPointsDailyCheckIn = (): AxiosPromise<boolean> => {
  return request({
    url: '/member/points/dailyCheckIn',
    method: 'post'
  });
};

// 完成任务
export const memberPointsCompleteTask = (pointsTaskId?: number): AxiosPromise<boolean> => {
  return request({
    url: '/member/points/completedTask',
    method: 'post',
    data: { pointsTaskId }
  });
};

// 个人积分明细列表
export const memberPointsRecordList = (data: RecordListRequest): AxiosPromise<MemberPointsRecordVo[]> => {
  return request({
    url: '/member/points/recordList',
    method: 'get',
    params: data
  });
};

// 积分任务列表
export const memberPointsTaskList = (): AxiosPromise<MemberPointsTaskVo> => {
  return request({
    url: '/member/points/taskList',
    method: 'get'
  });
};

// 获取个人积分
export const memberPointsPoints = (): AxiosPromise<{ points: number }> => {
  return request({
    url: '/member/points/points',
    method: 'get'
  });
};
